<template>
  <div class="pages">
    <headertop :activeName="activeName"/>

    <div class="index_title_top_2">
      <div class="top_content_menu">
        <div>品类齐全，轻松购物</div>
        <div>多仓直发，急速配送</div>
        <div>渠道直供，精挑细选</div>
        <div>正品好货，优质服务</div>
        <div>天天低价，畅选无忧</div>
      </div>
    </div>

    <div class="index_title_top_3">
      <div class="logo_input">
        <!-- <img src="../../../static/img/title.png" class="logo"> -->
        <div style="width: 180px;"></div>
        <div class="input_box">
          <input type="text" placeholder="请输入" class="input_item" @keyup.enter='toList' v-model='keywords'>
        </div>
        <div class="search-btn" @click="toList">
          <span class="iconfont icon-sousuo"></span>
        </div>
        <!-- <div class="my_carts">

          <span class="iconfont icon-gouwugouwuchedinggou" style="position: relative;">
            <span class="cart_num">7</span>
          </span>
          <span>我的进货单</span>
        </div> -->
      </div>
    </div>

    <!-- tab切换 -->
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick" class="tab">
      <el-tab-pane label="京东供应链" name="jingdong"></el-tab-pane>
      <el-tab-pane label="广电供应链" name="anguang"></el-tab-pane>
    </el-tabs>
    </div>
    <!-- banner -->
    <div class="banner">
      <!-- 左分类nav -->
      <div class="left_menu">
        <ul>
          <li class="item_li" v-for="(item, index) in bannerCateList" :key="item.categoryId"
            @mouseenter="onMouseEnter(item.categoryId)" @mouseleave="onMouseLeave()" @click="viewCate(item.categoryId, item.categoryName, item.categoryLevel)">
            <span>{{ item.categoryName }}</span>
            <span class="iconfont icon-arrow-right" v-if="item.categoryId"></span>

          </li>

        </ul>
      </div>
      <!-- 分类显示定位 -->
      <div class="children_cate" :style="{ display: childrenCate.categoryId ? '' : 'none' }" @mouseenter="onContentEnter"
        @mouseleave="onMouseLeave(1)">
        <div class="children_item" v-for="(item, index) in childrenCate.children" :key="index">
          <div class="title" @click="viewCate(item.categoryId, item.categoryName, item.categoryLevel)" style="cursor:pointer;">{{ item.categoryName }}</div>
          <div>
            <span v-for="(uitem, uindex) in item.children" style="margin: 0 10px;color: #444;cursor:pointer;"
              @click.stop="viewCate(uitem.categoryId, uitem.categoryName, uitem.categoryLevel)">{{ uitem.categoryName }}</span>
          </div>
        </div>
      </div>

      <!-- 中间轮播 -->
      <div style="width: 780px;height: 272px;">
        <el-carousel :interval="5000" arrow="always" loop>
          <el-carousel-item v-for="item in bannerList" :key="item.id">
            <img :src="$jx.oss(item.url)" alt="" style="width: 100%;height: 100%;">
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 右边功能按钮 -->
      <div>
        <div class="right_top">
          <div class="top">
            <div class="item_menu" @click="$router.push('/personcenter/account/account')">个人中心</div>
            <div class="item_menu" @click="$router.push('/personcenter/personcenter/balance')">钱包</div>
          </div>
          <div class="bottom">
            <div class="item_menu">联系客服</div>
            <!-- <div class="item_menu">下载中心</div> -->
          </div>
        </div>
        <div class="right_bottom">
          <ul>
            <!-- <li class="item_li">
              <span>上传excel批量下单</span>
            </li>
            <li class="item_li">
              <span>批量下单模板下载</span>
            </li> -->
            <li class="item_li" @click="$router.push('/personcenter/personcenter/applykey')">
              <span>API</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="goods_gift">
      <div class="goods_left">
        <div class="item_name">
          <div>礼包货源</div>
          <div style="display: none">
            <span>更多</span>
            <span class="iconfont icon-arrow-right"></span>
          </div>
        </div>
        <div class="goods_content">
          <div class="item_goods" v-for="(item, index) in goods_Array_6.slice(0, 3)" :key="item.id"
            @click="viewGoodsDetail(item.skuId)"  style="cursor:pointer">
            <div>
              <img :src="item.imageUrl" class="goods_img">
            </div>
            <div class="goods_name">
              <span>{{ item.skuName }}</span>
            </div>
            <div class="goods_desc">
              <span>{{ item.marketPrice }}元</span><span>京东价</span>
            </div>
            <div class="goods_desc">
              <span>{{ item.salePrice }}元</span><span>会员价</span>
            </div>
          </div>

        </div>
      </div>
      <div class="goods_right">
        <div class="item_name">
          <div>批发/零售货源</div>
          <div style="display: none">
            <span>更多</span>
            <span class="iconfont icon-arrow-right"></span>
          </div>
        </div>
        <div class="goods_content">
          <div class="item_goods" v-for="(item, index) in goods_Array_6.slice(3, 6)" :key="item.id"
            @click="viewGoodsDetail(item.skuId)" style="cursor:pointer">
            <div>
              <img :src="item.imageUrl" class="goods_img">
            </div>
            <div class="goods_name">
              <span>{{ item.skuName }}</span>
            </div>
            <div class="goods_desc">
              <span>{{ item.marketPrice }}元</span><span>京东价</span>
            </div>
            <div class="goods_desc">
              <span>{{ item.salePrice }}元</span><span>会员价</span>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="goods_class_1">
      <div class="title_name">
        <div class="title_left">
          <div class="class_name">
            <span>百亿补贴</span>
          </div>
          <div class="class_info">
            <span>千款巨惠 引爆全场</span>
          </div>
        </div>
        <div class="title_right" style="display: none">
          <span class="more">更多</span>
          <span class="iconfont icon-arrow-right arrow_right"></span>
        </div>
      </div>
      <div class="list_box">
        <div style="width: 100%;height: 300px;">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="(item, index) in goods_Array_1" :key="item.id" @click.native="viewGoodsDetail(item.skuId)" style="cursor:pointer">
              <img :src="item.imageUrl" alt="" class="lunbotu">
              <div class="swiper_goods_detail" style="z-index: 9;">
                <div class="goods_swiper_name">{{ item.skuName }}</div>
                <div class="goods_swiper_price_jd">
                  <div class="price">{{ item.marketPrice }}元</div>
                  <div class="img"></div>
                </div>
                <div class="goods_swiper_price_vip">
                  <div class="price">{{ item.salePrice }}元</div>
                  <div class="img"></div>

                </div>
              </div>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>


        </div>
      </div>

    </div>

    <div class="goods_class_1">
      <div class="title_name">
        <div class="title_left">
          <div class="class_name">
            <span>专款专区</span>
          </div>
          <div class="class_info">
            <span>下单需联系业务经理获取授权</span>
          </div>
        </div>
        <div class="title_right" style="display: none">
          <span class="more">更多</span>
          <span class="iconfont icon-arrow-right arrow_right"></span>
        </div>
      </div>
      <div class="list_box">
        <div style="width: 100%;height: 300px;">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="(item, index) in goods_Array_2" :key="item.id" @click.native="viewGoodsDetail(item.skuId)" style="cursor:pointer">
              <img :src="item.imageUrl" alt="" class="lunbotu">
              <div class="swiper_goods_detail">
                <div class="goods_swiper_name">{{ item.skuName }}</div>
                <div class="goods_swiper_price_jd">
                  <div class="price">{{ item.marketPrice }}元</div>
                  <div class="img"></div>
                </div>
                <div class="goods_swiper_price_vip">
                  <div class="price">{{ item.salePrice }}元</div>
                  <div class="img"></div>

                </div>
              </div>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>


        </div>
      </div>

    </div>

    <div class="goods_class_1">
      <div class="title_name">
        <div class="title_left">
          <div class="class_name">
            <span>每月上新</span>
          </div>
          <div class="class_info">
            <span>金秋九月 上新榜单</span>
          </div>
        </div>
        <div class="title_right" style="display: none">
          <span class="more">更多</span>
          <span class="iconfont icon-arrow-right arrow_right"></span>
        </div>
      </div>
      <div class="list_box">
        <div style="width: 100%;height: 300px;">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="(item, index) in goods_Array_3" :key="item.id" @click.native="viewGoodsDetail(item.skuId)" style="cursor:pointer">
              <img :src="item.imageUrl" alt="" class="lunbotu">
              <div class="swiper_goods_detail">
                <div class="goods_swiper_name">{{ item.skuName }}</div>
                <div class="goods_swiper_price_jd">
                  <div class="price">{{ item.marketPrice }}元</div>
                  <div class="img"></div>
                </div>
                <div class="goods_swiper_price_vip">
                  <div class="price">{{ item.salePrice }}元</div>
                  <div class="img"></div>

                </div>
              </div>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>

    </div>
    <div class="goods_class_1">
      <div class="title_name">
        <div class="title_left">
          <div class="class_name">
            <span>热销爆品</span>
          </div>
          <div class="class_info">
            <span>无限回购 TOP榜单</span>
          </div>
        </div>
        <div class="title_right" style="display: none">
          <span class="more">更多</span>
          <span class="iconfont icon-arrow-right arrow_right"></span>
        </div>
      </div>
      <div class="list_box">
        <div style="width: 100%;height: 300px;">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="(item, index) in goods_Array_4" :key="item.id" @click.native="viewGoodsDetail(item.skuId)" style="cursor:pointer">
              <img :src="item.imageUrl" alt="" class="lunbotu">
              <div class="swiper_goods_detail">
                <div class="goods_swiper_name">{{ item.skuName }}</div>
                <div class="goods_swiper_price_jd">
                  <div class="price">{{ item.marketPrice }}元</div>
                  <div class="img"></div>
                </div>
                <div class="goods_swiper_price_vip">
                  <div class="price">{{ item.salePrice }}元</div>
                  <div class="img"></div>

                </div>
              </div>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>


        </div>
      </div>

    </div>
    <div class="goods_class_1">
      <div class="title_name">
        <div class="title_left">
          <div class="class_name">
            <span>每周新品推荐</span>
          </div>
          <div class="class_info">
            <span>每周上新</span>
          </div>
        </div>
        <div class="title_right" style="display: none">
          <span class="more">更多</span>
          <span class="iconfont icon-arrow-right arrow_right"></span>
        </div>
      </div>
      <div class="list_box">
        <div style="width: 100%;height: 300px;">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="(item, index) in goods_Array_5" :key="item.id" @click.native="viewGoodsDetail(item.skuId)" style="cursor:pointer">
              <img :src="item.imageUrl" alt="" class="lunbotu">
              <div class="swiper_goods_detail">
                <div class="goods_swiper_name">{{ item.skuName }}</div>
                <div class="goods_swiper_price_jd">
                  <div class="price">{{ item.marketPrice }}元</div>
                  <div class="img"></div>
                </div>
                <div class="goods_swiper_price_vip">
                  <div class="price">{{ item.salePrice }}元</div>
                  <div class="img"></div>

                </div>
              </div>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>

    </div>




    <div class="footer_goods_area">
      <div class="recommend"></div>
      <div class="cate_box">
        <div @click="changeCate(item.categoryId)" :class="{ active_cate: cateId === item.categoryId }" class="item_cate"
          v-for="(item, index) in cateList" :key="item.categoryId">{{ item.categoryName }}</div>
      </div>

      <div class="all_goods_box">
        <div class="item_goods_box" v-for="(item, index) in goodsList" :key="item.id" @click="viewGoodsDetail(item.skuId)" style="cursor:pointer">
          <div class="item_goods_image_box">
            <img :src="item.imageUrl" alt="">
          </div>
          <div class="goods_name_item">
            <div></div>
            <div>{{ item.skuName }}</div>
          </div>
          <div>
            <div class="goods_code">
              <span>品牌:</span><span>{{ item.brandName }}</span>
            </div>
          </div>
          <div>
            <div class="goods_price">
              <div>{{ item.marketPrice }}元</div>
              <div class="jd_img"></div>
            </div>
          </div>
          <div>
            <div class="goods_price">
              <div>{{ item.salePrice }}元</div>
              <div class="vip_img"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="load_more">
      <span>{{ load_Text }}</span>
    </div>
    <div style="height: 20px;"></div>
  </div>
</template>

<script>
import headertop from '@/components/headglobal/headglobal.vue'
export default {
  inject: ["reload"],
  components: {
    headertop
  },
  data() {
    return {
      activeName: 'jingdong',
      cateId: "",
      reclassify: false,
      dataList: [],
      bannerCateList: [],
      keywords:"",
      childrenCate: {},
      settimer: null,
      cateList: [],

      swiperOption: {
        slidesPerView: 6,  //一行显示3个
        spaceBetween: 30,  //间隔30
        freeMode: true,
        speed: 100,   //滑动速度
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      },


      bannerList: [],





      userid: "",
      appId: "",
      secret: "",
      allGoodsList: [],
      goodsList: [],
      page: 1,
      size: 20,
      total: 0,
      Loading: false,
      load_Text: "上滑加载更多",
      isfinished: false,
      cateGoodsList: [],

      goods_left: [],
      goods_right: [],

      goods_Array_1: [],
      goods_Array_2: [],
      goods_Array_3: [],
      goods_Array_4: [],
      goods_Array_5: [],
      goods_Array_6: [],
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  created() {
    localStorage.setItem('activeName', this.activeName)
    this.userid = this.$store.state.user.userinfo.id
    this.getAppId()
    this.getBanner()
  },
  mounted() {
    window.addEventListener("scroll", this.checkedDom)
  },
  methods: {
    handleClick(tab) {
      this.activeName = tab.name
      localStorage.setItem('activeName', this.activeName)
      this.getAppId()
    },
    // 获取个人的APPID和secret
    getAppId() {
      this.$http.get("/user/getUserAppidSecret").then(res => {
        if (res.code === 1) {
          this.appId = res.data.appid
          this.secret = res.data.secret
          
          this.getBannerCate()
          this.getAllCate()
          this.getItemSwiperGoods()
        }
      })
    },
    onMouseEnter(id) {
      if (this.settimer) {
        clearTimeout(this.settimer)
        this.settimer = null
      }
      if (id) {
        this.childrenCate = this.bannerCateList.find(item => item.categoryId === id)
      } else {
        this.childrenCate = {}
      }
    },
    onContentEnter() {
      if (this.settimer) {
        clearTimeout(this.settimer)
        this.settimer = null
      }
    },
    onMouseLeave(type = 0) {
      if (type === 0) {
        this.settimer = setTimeout(() => {
          this.childrenCate = {}
        }, 1000);
      } else if (type === 1) {
        this.settimer = setTimeout(() => {
          this.childrenCate = {}
        });
      }

    },
    // 获取主页商品 
    getIndexAllGoods() {
      if (this.Loading) return
      this.Loading = true
      this.load_Text = "加载中..."
      this.$http.post("/v2/goods/lists", {
        page: this.page,
        category_id_1: this.cateId,
        size: this.size,
        appid: this.appId,
        secret: this.secret,
        source: this.activeName
      }).then(res => {
        this.Loading = false
        this.goodsList.push(...res.data.items)
        this.total = res.data.pageItemTotal
        this.load_Text = "上拉加载更多"
        this.page++
      })
    },

    getItemSwiperGoods() {
      const limit = 10
      const arr = [1, 2, 3, 4, 5, 6]
      arr.forEach(item => {
        this.$http.post("/v2/goods/lists", {
          page: item,
          size: limit,
          appid: this.appId,
          secret: this.secret,
          source: this.activeName
        }).then(res => {
          if (item === 1) {
            this.goods_Array_1 = res.data.items
          }
          if (item === 2) {
            this.goods_Array_2 = res.data.items
          }
          if (item === 3) {
            this.goods_Array_3 = res.data.items
          }
          if (item === 4) {
            this.goods_Array_4 = res.data.items
          }
          if (item === 5) {
            this.goods_Array_5 = res.data.items
          }
          if (item === 6) {
            this.goods_Array_6 = res.data.items
          }
        })
      })


    },
    // 分类
    getAllCate() {
      this.$http.post("/v2/goods/getRecommendCategory",{
        appid: this.appId,
        secret: this.secret,
        source: this.activeName
      }).then(res => {

        this.cateList = res.data.slice(0, 8)
        this.cateId = res.data[0].categoryId

        this.getIndexAllGoods()
      })
    },

    getBannerCate() {
      this.$http.post("/v2/goods/category",{
        appid: this.appId,
        secret: this.secret,
        source: this.activeName
      }).then(res => {
        const sysCate = res.data.filter(item => item.parentId === 0)


        sysCate.forEach(item => {
          this.$set(item, "children", [])
        })

        for (let i = 0; i < sysCate.length; i++) {
          res.data.forEach(item => {
            if (item.parentId === sysCate[i].categoryId) {
              sysCate[i].children.push(item)
            }
          })
        }
        sysCate.forEach(item => {
          item.children.forEach(i => {
            this.$set(i, "children", [])
          })
        })

        for (let i = 0; i < sysCate.length; i++) {
          for (let j = 0; j < sysCate[i].children.length; j++) {
            res.data.forEach(item => {
              if (item.parentId === sysCate[i].children[j].categoryId) {
                sysCate[i].children[j].children.push(item)
              }
            })
          }
        }
        // this.bannerCateList.push(...sysCate)
        const dddd = sysCate.filter(item => item.children.length > 2)
        // console.log(dddd, 'ddddddddddddddddddd');
        // this.bannerCateList.push(...dddd)
        this.bannerCateList = [...dddd]
      })
    },


    getBanner() {
      this.$http.get("/index/getBanner", {
        num: 4
      }).then(res => {
        this.bannerList = res.data
      })
    },


    checkedDom() {
      if (this.Loading) return
      if (this.isfinished) return
      const element = document.querySelector('#load_more');
      if (element) {
        const rect = element.getBoundingClientRect();
        if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
          if (this.goodsList.length < this.total) {
            this.getIndexAllGoods()
          } else {
            this.load_Text = "没有更多了"
            this.isfinished = true
          }
        }
      }
    },
    changeCate(id) {
      this.cateId = id
      this.page = 1
      this.total = 0
      this.goodsList = []
      this.isfinished = false
      this.getIndexAllGoods()
    },

    viewGoodsDetail(id) {
      // 新开浏览器页面跳转，需要改baseURL
      // this.$jx.open_blank(`/goodsdetail/goodsdetail/${id}`)
      // 普通路由跳转
      // this.$router.push(`/goodsdetail/goodsdetail/${id}`)
       this.$router.push({
        name: 'goodsdetail',
        params: {
          id: id
        },
        query: {
          activeName: this.activeName
        }
      });

    },
    viewCate(id, name, level) {
      localStorage.setItem('catetitle', name)
      localStorage.setItem('catelevel', level)
      // this.$router.push(`/categoodslist/categoodslist/${id}`)
      this.$router.push({
        name: 'categoodslist',
        params: {
          cate_id: id
        },
        query: {
          activeName: this.activeName
        }
      });
    },
    toList(){
      if(this.keywords == ''){
        return;
      }
      // this.$router.push(`/lists/`+this.keywords)
      this.$router.push({
        name: 'list',
        params: {
          keywords: this.keywords
        },
        query: {
          activeName: this.activeName
        }
      });
    }


  }
};
</script>

<style scoped lang="scss">
.pages {
  background-color: #f5f5f5;
}

.lunbotu {
  width: 100%;
  height: 200px;
}

.swiper-button-prev,
.swiper-button-next {
  width: 27px;
  height: 20px;
}

* {
  box-sizing: border-box;
}

.index_title_top {
  height: 46px;
  background-color: #efefef;

  .top_content_menu {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    height: 100%;
  }

  .menu_left,
  .menu_right {
    flex: 1;
    display: flex;
  }

  .menu_right {
    position: relative;
  }



  .item_menu {
    flex: 1;
    text-align: center;
    font-size: 12px;
    line-height: 46px;
  }

  .item_menu:hover {
    color: #da1f34;
  }

  .drow_button {
    color: #000;
    border: none !important;
    background-color: transparent !important;
    padding: 0 2px;
  }

  .my_goods_order {
    display: flex;
    justify-content: space-around;
    padding: 0 10px;
  }

  .user_menu:hover,
  .my_goods_order:hover {
    color: #fff !important;
    background-color: #da1f34;

    .drow_button {
      background-color: #da1f34 !important;
      color: #fff !important;
    }

  }

  .arrow_down {
    display: inline-block;
    width: 20px;
    height: 10px;
    background-image: url('../../../static/img/shopcar_2.png');
    background-size: contain;
    background-repeat: no-repeat;
  }

  .cart_icon {
    display: inline-block;
    width: 14px;
    height: 12px;
    background-image: url('../../../static/img/shopcar_1.png');
    background-size: contain;
    background-repeat: no-repeat;
  }
}


.index_title_top_2 {
  height: 46px;
  background-color: #fff;
  border-bottom: 1px solid #ccc;

  .top_content_menu {
    display: flex;
    justify-content: space-around;
    padding: 12px 100px;
    font-size: 14px;
  }

}

.index_title_top_3 {
  box-sizing: border-box;
  height: 103px;
  background-color: #fff;
  padding: 30px 0;

  .logo_input {
    width: 1200px;
    margin: 0 auto;
    display: flex;
  }

  .logo {
    width: 180px;
    height: 40px;
  }

  .input_box {
    border: 1px solid #fd2632;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    padding: 0 16px;
    width: 558px;
    height: 40px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .my_carts {
    border: 1px solid #fd2632;
    border-radius: 6px;
    padding: 11px 38px;
    margin-left: 20px;
    cursor: pointer;
    position: relative;
    font-size: 14px;
    color: #fd2632;

    .cart_num {
      position: absolute;
      right: -5px;
      top: -8px;
      font-size: 12px;
      padding: 0 2px;
      border-radius: 20px;
      background-color: #fd2632;
      color: #fff;
      font-size: 12px;
    }
  }

  .input_item {
    border: none !important;
    height: 100%;
    width: 100%;
  }

  .input_item:focus {
    outline: none;
  }

  .search-btn {
    background-color: #fd2632;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    height: 40px;
    padding: 0 32px;
    cursor: pointer;
    line-height: 40px;
    color: #fff;
  }
}


.left_menu {
  box-sizing: border-box;
  color: #000;
  width: 220px;
  height: 272px;
  overflow: auto;
  background-color: #fff;
  border-radius: 5px;
  margin-right: 10px;
  padding: 10px 0;
  font-size: 14px;

  &::-webkit-scrollbar {
    display: none;
  }

  .item_li {
    box-sizing: border-box;
    width: 220px;
    height: 41px;
    padding: 11px 14px 11px 20px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      color: #fff;
      background-color: #fd2632;

    }
  }
}

.right_top {

  width: 234px;
  height: 110px;
  padding: 20px 14px 6px;
  border-radius: 5rpx;
  background-color: #fff;
  margin-left: 10px;

  .top,
  .bottom {
    display: flex;
  }

  .item_menu {
    flex: 1;
    height: 28px;
    margin-bottom: 14px;
    cursor: pointer;
  }

}

.right_bottom {
  width: 234px;
  height: 148px;
  margin-top: 14px;
  padding: 15px 14px;
  border-radius: 5px;
  background-color: #fff;
  margin-left: 10px;

  .item_li {
    height: 31px;
    border: 1px solid #d3b582;
    border-radius: 5px;
    padding: 5px 0;
    text-align: center;
    margin-bottom: 12px;
    color: #ae8c51;
    cursor: pointer;
  }
}

.goods_gift {
  width: 1200px;
  height: 375px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;

  .goods_left,
  .goods_right {
    flex: 0 0 48%;
    min-height: 100%;
    background-color: #fff;
    border-radius: 5px;
    padding: 20px;
  }

  .item_name {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    font-size: 22px;
  }

  .goods_content {
    display: flex;
    justify-content: space-between;
  }

  .item_goods {
    flex: 0 0 32%;
    background-color: #fff;
    min-height: 280px;
    border-radius: 8px;
    overflow: hidden;
    padding-bottom: 10px;
  }

  .goods_img {
    width: 100%;
    height: 190px;
  }

  .goods_name {
    font-size: 14px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 10px;
    margin-bottom: 5px;
  }

  .goods_desc {
    font-size: 14px;
    padding: 0 10px;
  }

}

.goods_class_1 {
  box-sizing: border-box;
  width: 1200px;
  margin: 20px auto;
  min-height: 350px;
  background-color: #fff;
  border-radius: 8px;
  padding: 16px 0 0;
  position: relative;

  .title_name {
    display: flex;
    justify-content: space-between;
    padding: 0 24px;
  }

  .class_name {
    font-size: 22px;
  }

  .class_info {
    font-size: 15px;
  }

  .title_right .more {
    color: #999;
    font-size: 14px;
  }

  .arrow_right {
    border: 1px solid #999;
    border-radius: 50%;
  }


  .prev,
  .next {
    position: absolute;
  }

  .prev {
    left: 24px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 36px;
  }

  .next {
    right: 24px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 36px;
  }

  .list_box {
    width: 100%;
    overflow: hidden;
    height: 300px;
    position: relative;
    margin: 20px 0 0;
  }


  .goods_item_box {
    width: 200px;
    height: 300px;
    margin-right: 5px;
    background-color: darkkhaki;
    font-size: 14px;

  }
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

// /deep/ .el-carousel__indicators {
//   display: none !important;
// }



.footer_goods_area {
  width: 1200px;
  margin: 40px auto;
  min-height: 200px;



  .recommend {
    width: 206px;
    height: 30px;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('../../../static/img/title_2.png');
  }

  .cate_box {
    display: flex;
    justify-content: space-around;
    margin-top: 30px;
    background-color: #fff;
    padding: 20px 0;
  }

  .item_cate {
    padding: 3px 15px;
    border-radius: 40px;
    color: #000;
    cursor: pointer;
  }

  .active_cate {
    padding: 3px 15px;
    border-radius: 40px;
    background-color: #ff2e2d;
    color: #fff;
  }

  .all_goods_box {
    margin-top: 40px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .item_goods_box {
    width: calc((100% - 4 * 20px) / 5);
    margin-right: 20px;
    min-height: 300px;
    background-color: #fff;
    margin-bottom: 20px;
    padding: 20px;
    border-radius: 8px;
  }

  .item_goods_box:nth-child(5n) {
    margin-right: 0 !important;
  }

  .item_goods_image_box {
    width: 100%;
    height: 200px;

    img {
      width: 100%;
      height: 100%;
      border-radius: 5px;
    }
  }


  .goods_name_item {
    font-size: 14px;
    display: flex;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /* 控制行数 */
    -webkit-box-orient: vertical;
    /* 垂直方向排列文本 */
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 8px;
  }

  .goods_code {
    font-size: 12px;
    margin-top: 2px;
  }

  .goods_price {
    display: flex;
    font-size: 14px;
  }

  .jd_img,
  .vip_img {
    width: 42px;
    height: 14px;
    margin-left: 8px;
    background-size: contain;
    background-repeat: no-repeat;
    margin-top: 2px;
  }

  .jd_img {
    background-image: url('../../../static/tag_jd.png');
  }

  .vip_img {
    background-image: url('../../../static/tag_vip.png');
  }







}

#load_more {
  width: 1200px;
  margin: 30px auto;
  font-size: 14px;
  text-align: center;
  color: #666;
}
.tab {
  width: 60%;
  margin: 40px auto;
}
.banner {
  display: flex;
  width: 1200px;
  margin: 0 auto;
  position: relative;




  .children_cate {
    width: 985px;
    height: 100%;
    background-color: #fff;
    position: absolute;
    left: 215px;
    top: 0;
    z-index: 999;
    display: flex;
    flex-wrap: wrap;
    padding: 20px;
    font-size: 14px;
    justify-content: space-between;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    .children_item {
      width: 49%;
      margin-bottom: 10px;

      .title {
        padding: 5px;
        border-bottom: 1px solid #ccc;
        margin-bottom: 5px;
        font-weight: 700;
      }
    }


  }


}

.swiper_goods_detail {
  padding: 0 10px 10px;


  .goods_swiper_name {
    font-size: 14px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .goods_swiper_price_jd,
  .goods_swiper_price_vip {
    display: flex;
    font-size: 14px;
  }

  .goods_swiper_price_jd {
    margin-top: 5px;
    color: #db2423;


    .img {
      width: 42px;
      height: 14px;
      margin-left: 8px;
      background-size: contain;
      background-repeat: no-repeat;
      margin-top: 2px;
      background-image: url('../../../static/tag_jd.png');
    }



  }

  .goods_swiper_price_vip {
    color: #d3b582;
    font-weight: 700;

    .img {
      width: 42px;
      height: 14px;
      margin-left: 8px;
      background-size: contain;
      background-repeat: no-repeat;
      margin-top: 2px;
      background-image: url('../../../static/tag_vip.png');
    }
  }
}

/deep/ .el-carousel__container {
  height: 272px;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 272px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
</style>



// WEBPACK FOOTER //
// src/views/main/index.vue